import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'content'
})`
  justify-content: space-between;

  form {
      margin-left: -5.5%;
      margin-right: -5.5%;
      margin-top: 14px;
  }

  .login__btn--biggest {
      margin-bottom: 0 !important;
  }

  .login__title {
      font-size: 16px;
  }
`;
